import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const MyIconButton = (props) => {
  const [iconLeft, setIconLeft] = useState(null);
  const [centerIcon, setCenterIcon] = useState(null);
  const [iconRight, setIconRight] = useState(null);

  useEffect(() => {

    // Définition de l'icône à gauche
    if (props.iconLeft) {
      if (props.iconLeft.type === 'fontAwesome') {
        setIconLeft(<span style={{ marginRight: '10px' }}><FontAwesomeIcon icon={props.iconLeft.icon} color={props.iconLeft.color} /></span>);
      } else {
        setIconLeft(<span>{props.iconLeft.icon}</span>);
      }
    } else {
      setIconLeft(null);
    }

    // Définition de l'icône au center
    if (props.iconCenter) {
      if (props.iconCenter.type === 'fontAwesome') {
        setCenterIcon(<span><FontAwesomeIcon icon={props.iconCenter.icon} color={props.iconCenter.color} /></span>);
      } else {
        setCenterIcon(<span>{props.iconCenter.icon}</span>);
      }
    } else {
      setCenterIcon(null);
    }

    // Définition de l'icône à droite
    if (props.iconRight) {
      if (props.iconRight.type === 'fontAwesome') {
        setIconRight(<span style={{ marginLeft: '10px' }}><FontAwesomeIcon icon={props.iconRight.icon} color={props.iconRight.color} /></span>);
      } else {
        setIconRight(<span>{props.iconRight.icon}</span>);
      }
    } else {
      setIconRight(null);
    }
  }, [props]);

  return (
    <Link
      type={props.type}
      onClick={!props.isLoading ? props.onClick : null}
      className={props.isLoading ? 'btn-loading' : props.className}
      to={props.href}
      style={props.styleCss}>
      {props.isLoading &&
        <>
          <FontAwesomeIcon icon={faSpinner} spin={true} style={{ marginRight: '10px' }} />
          Traitement en cours...
        </>
      }
      {!props.isLoading &&
        <>
          {iconLeft}
          {centerIcon}
          {props.label}
          {props.labelImportant && <b>{props.labelImportant}</b>}
          {iconRight}
        </>
      }
    </Link>
  );

};

export default MyIconButton;
